class e{load(e,o,r){throw new Error("not implemented")}open(e,o,r){throw new Error("not implemented")}patch(e,o){}}export{e as ResourceHandler};
